import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCleanseGlyph from './svgs/CleanseGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var cleanseGlyph = (props => useIcon(SvgCleanseGlyph, SvgCleanseGlyph, props));

export { cleanseGlyph as default };
